var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMyList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.504 7.778c-1.898-2.482-4.22-2.8-5.837-2.633-2.292.24-4.424 1.583-5.667 3.047-1.243-1.464-3.375-2.808-5.667-3.047-1.61-.167-3.938.151-5.837 2.633-1.239 1.62-1.704 3.47-1.38 5.496.97 6.102 8.998 12.208 12.405 14.55a1 1 0 001.133 0C20.01 25.516 27.921 19.486 28.9 13.34c.326-2.052-.143-3.923-1.396-5.562",
    fill: props.color
  })));
}

export default SvgIconMyList;